// @owners { team: patient-health }
import { push } from 'react-router-redux';
import { setSelectedVideo } from '~shared/actions/instructionalVideos';
import { getAddress } from '~shared/features/addresses/selectors/getAddress';
import { getNextUpcomingDeliveryForPrescription } from '~shared/features/delivery/selectors/getUpcomingDeliveriesForPrescription';
import { getIsVideosEnabled } from '~shared/features/instructional-videos/selectors/getIsVideosEnabled';
import { type Video } from '~shared/features/instructional-videos/types';
import { makeGetMedicationTagKey } from '~shared/features/my-meds/selectors/getMedicationTagKey';
import {
  getActiveActionablePrescriptions,
  getPartitionedPrescriptionsForMedication,
} from '~shared/features/my-meds/selectors/getPartitionedPrescriptionsByMedication';
import { formatDeliveryDetails } from '~shared/helpers/delivery';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { DESTINATION_NAMES, generateSupportViewedEvent } from '~shared/lib/analytics/src/events/getSupportViewed';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import MedListRow from './MedListRow';

// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
function mapStateToProps(state: ReduxStateShared, ownProps) {
  const { medication } = ownProps;
  const includeFertVideos = getIsVideosEnabled(state);
  const { key: tagKey, data: tagData } = makeGetMedicationTagKey(state, ownProps);
  const { actionablePrescriptions } = getPartitionedPrescriptionsForMedication(state, { medication });
  const activePrescriptions = getActiveActionablePrescriptions(state, { medication });
  const upcomingDelivery = getNextUpcomingDeliveryForPrescription(state, {
    prescription: medication.representativePrescription,
  });
  const address = getAddress(state, { addressID: upcomingDelivery?.address_id });
  const upcomingDeliveryDetails = formatDeliveryDetails(address, upcomingDelivery);

  return {
    actionablePrescriptions,
    activePrescriptions,
    includeFertVideos,
    tagKey,
    tagData,
    upcomingShipmentID: upcomingDelivery?.shipment_id,
    upcomingDeliveryDetails,
  };
}

function mapDispatchToProps(dispatch: ReduxDispatchShared) {
  return {
    onClickVideoIcon: (video: Video) => {
      dispatch(setSelectedVideo(video));
      dispatch(
        sendAnalyticsEvent(generateSupportViewedEvent(ORIGIN_NAMES.MED_LIST, DESTINATION_NAMES.FERTILITY_VIDEOS)),
      );
      dispatch(push('/me/fertility-videos'));
    },
    // @ts-expect-error TS(7006): Parameter 'event' implicitly has an 'any' type.
    sendAnalyticsEvent: (event) => {
      dispatch(sendAnalyticsEvent(event));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MedListRow);
